import { useMemo } from "react";

import { Pin } from "components/icons/generated";

import type { MainNavigationItem } from "../types";

export const MAIN_NAVIGATION_PINNED_GROUP_ID = "pinned";

const usePinnedGroup = (pinnedItems: MainNavigationItem[]): MainNavigationItem => {
  return useMemo(
    () => ({
      id: MAIN_NAVIGATION_PINNED_GROUP_ID,
      title: "Pinned",
      icon: Pin,
      items: [...(pinnedItems.length > 0 ? [{ items: pinnedItems }] : [])],
    }),
    [pinnedItems]
  );
};

export default usePinnedGroup;
